import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  accounts: {
    assets: [],
    liabilities: [],
    expenses: [],
    incomes: [],
    transfer: [],
  },
  account: false,
  loading: false,
  formLoading: false,
  error: false,
  success: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Accounts/index.js